import React from 'react';
import Grid from '@material-ui/core/Grid';
import SteppedBar from 'components/Bars/SteppedBar';
import useGeneralStyles from 'apps/Pdf/styles/general';
import useStyles from './EvaluationCategoryStyle';

interface Props {
  risk?: string;
  category: string;
  minValueLabel?: string;
  maxValueLabel?: string;
  total?: boolean;
  fe?: boolean;
  esg?: string;
}

const EvaluationCategory = (props: Props) => {
  const styles = useGeneralStyles();
  const classes = useStyles();

  return (
    <Grid container className={`${styles.box} ${classes.root} ${props.total ? 'total bgrLighter' : ''}`} spacing={0}>
      {props.total ? (
        <>
          <Grid item xs={12} className={`${styles.mediumText} title`}>
            {props.category}
          </Grid>
          <Grid item xs={props.fe ? 3 : 2} sm={2} className={`${styles.right} minLabel`}>
            {props.minValueLabel}
          </Grid>
          <Grid item xs={props.fe ? 6 : 8} sm={8} className="gauge gaugeWrapper">
            {props.risk && <SteppedBar currentValue={props.risk} className={`total ${props.fe?'iqResult':''}`} />}
          </Grid>
          <Grid item xs={props.fe ? 3 : 2} sm={2} className={`${styles.left} maxLabel`}>
            {props.maxValueLabel}
          </Grid>
        </>
      ) : props.esg ? (
        <>
          <Grid item xs={props.fe ? 12 : 6} sm={5} className={`${styles.regularText} title text`}>
            {props.category}:
          </Grid>
          <Grid item xs={props.fe ? 12 : 6} sm={7} className={`text`}>
            {props.esg}
          </Grid>
        </>
      ) : (
        <>
          <Grid item xs={props.fe ? 12 : 3} sm={3} className={`${styles.regularText} title`}>
            {props.category}:
          </Grid>
          <Grid item xs={3} sm={2} className={`${styles.right} minLabel`}>
            {props.minValueLabel}
          </Grid>
          <Grid item xs={props.fe ? 6 : 3} sm={5} className="gauge gaugeWrapper">
            {props.risk && <SteppedBar currentValue={props.risk} className={`overview ${props.fe?'iqResult':''}`} />}
          </Grid>
          <Grid item xs={3} sm={2} className={`${styles.left} maxLabel`}>
            {props.maxValueLabel}
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default EvaluationCategory;
